import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { notEmpty } from "../utils";
import { useSubscriptionWithSkip } from "../utils/useSubscriptionWithSkip";
import { useWidgetTeamScheduleSubscription } from "./__generated__/useWidgetTeamScheduleSubscription.graphql";
import { useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion$key } from "./__generated__/useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion.graphql";

export function useWidgetTeamScheduleSub(
  events: useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion$key,
  skip: boolean
) {
  const eventOccasions = useFragment(
    graphql`
      fragment useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion on TeamScheduleEventOccasion
      @relay(plural: true) {
        id
        ... on TeamScheduleInlineRoutineOccasion {
          taskExecution {
            routine {
              id
            }
          }
        }
        ... on RoutineOccasion {
          routine {
            id
          }
        }
      }
    `,
    events
  );

  const routineIds = useMemo(
    () =>
      eventOccasions
        ?.map((o) => o.taskExecution?.routine?.id ?? o?.routine?.id)
        .filter(notEmpty) ?? [],
    [eventOccasions]
  );

  useSubscriptionWithSkip<useWidgetTeamScheduleSubscription>(
    useMemo(
      () => ({
        variables: {
          routineIds,
        },
        subscription: graphql`
          subscription useWidgetTeamScheduleSubscription($routineIds: [ID!]!) {
            routineTaskExecutionChanged(routineIds: $routineIds) {
              id
              isCompleted
              routineOccasion {
                id
                status(
                  calculateNoTasks: true
                  calculateNotCompletedStarted: true
                )
              }
            }
          }
        `,
      }),
      [routineIds]
    ),
    { skip: routineIds.length === 0 || skip }
  );
}
